'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Header, _Component);

  function Header() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call.apply(_ref, [this].concat(args))), _this), _this.onCancel = function (event) {
      if (event && event.preventDefault) event.preventDefault();
      if (!_this.props.isStatic && _this.props.onCancel) _this.props.onCancel(event, null);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Header, [{
    key: 'render',
    value: function render() {
      var _cx2;

      /* eslint no-unused-vars: 0, react/prop-types: 0 */
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          addClose = _props.addClose,
          onCancel = _props.onCancel,
          isStatic = _props.isStatic,
          isBasic = _props.isBasic,
          rest = (0, _objectWithoutProperties3.default)(_props, ['className', 'children', 'addClose', 'onCancel', 'isStatic', 'isBasic']);

      var styles = require('./Header.scss');

      if (typeof children !== 'string') return children;

      var closeBtn = addClose ? _react2.default.createElement(
        'button',
        {
          className: (0, _classnames2.default)(styles.close, (0, _defineProperty3.default)({}, className + '__close', className)),
          'aria-label': 'Close',
          onClick: this.onCancel
        },
        _react2.default.createElement(
          'span',
          { 'aria-hidden': 'true' },
          '\xD7'
        )
      ) : null;

      var classModifiers = (0, _classnames2.default)((_cx2 = {}, (0, _defineProperty3.default)(_cx2, styles['root--static'], isStatic), (0, _defineProperty3.default)(_cx2, className + '--static', className && isStatic), (0, _defineProperty3.default)(_cx2, styles['root--basic'], isBasic), (0, _defineProperty3.default)(_cx2, className + '--basic', className && isBasic), _cx2));

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, rest, { className: (0, _classnames2.default)(className, styles.root, classModifiers) }),
        _react2.default.createElement(
          'h1',
          { className: (0, _classnames2.default)(styles.title, (0, _defineProperty3.default)({}, className + '__title', className)) },
          children
        ),
        closeBtn
      );
    }
  }]);
  return Header;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.node,
  isStatic: _react.PropTypes.bool,
  isBasic: _react.PropTypes.bool,
  addClose: _react.PropTypes.bool,
  onCancel: _react.PropTypes.func,
  className: _react.PropTypes.string
}, _class.defaultProps = {
  addClose: true
}, _temp2);
exports.default = Header;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseModal/Header/Header.jsx
// module id = 1603
// module chunks = 0